/**
 * ApiContext — contexto que disponibiliza o cliente HTTP para toda a árvore React.
 *
 * Separado de client.js para evitar import circular
 * (client.js importa ApiContext; ApiProvider importa client.js).
 *
 * Valor do contexto:
 *   client    — ApiClient com get/post/patch/put/delete/request
 *   _getToken — getter do access token atual (usado pelo openStream do SSE,
 *               que não pode usar EventSource nativo pois precisa de header Authorization)
 */
import { createContext } from 'react';

/** @type {React.Context<{ client: import('./client').ApiClient, _getToken: () => string|null } | null>} */
export const ApiContext = createContext(null);
